export default "__VITE_ASSET__DYIVDTua__"